module.exports = "<div class=ui-grid-cell-contents> {{row.entity.startHour.substring(0,5)}} - {{row.entity.endHour.substring(0,5)}} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/teaching/studentAttention/listSchedules/cellSchedule.html
// module id = 736
// module chunks = 0